import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Clear the auth token
        Cookies.remove("authToken");

        // Redirect to login page
        navigate("/login");
    }, [navigate]);

    return null; // No UI needed, just logic
};

export default Logout;
